var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebsite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14.857,
    height: 14.857,
    viewBox: "0 0 14.857 14.857",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1745",
    "data-name": "Rectangle 1745",
    width: 14.857,
    height: 14.857,
    transform: "translate(-1 -1)",
    fill: "none",
    stroke: "#16161a",
    strokeWidth: 1.6
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3125",
    "data-name": "Group 3125",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3124",
    "data-name": "Group 3124",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8470",
    "data-name": "Path 8470",
    d: "M7.262.931A6.124,6.124,0,0,1,13.47,6.955a6.124,6.124,0,0,1-6.207,6.024A6.124,6.124,0,0,1,1.056,6.955,6.124,6.124,0,0,1,7.262.931Zm0,10.447A4.523,4.523,0,0,0,11.87,6.955,4.523,4.523,0,0,0,7.262,2.531,4.523,4.523,0,0,0,2.656,6.955,4.523,4.523,0,0,0,7.262,11.378Z",
    transform: "translate(-0.53 -0.495)",
    fill: "#16161a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8471",
    "data-name": "Path 8471",
    d: "M11,13.229a2.242,2.242,0,0,1-.512-.06,14.408,14.408,0,0,1-6.028-3.8C1.871,6.865.2,4.1.2,2.311A2.066,2.066,0,0,1,.795.763,2.561,2.561,0,0,1,3.289.314a.8.8,0,0,1-.355,1.56c-.589-.134-.918-.067-1.029.04a.612.612,0,0,0-.106.4c0,1.088,1.18,3.4,3.77,5.9a13.056,13.056,0,0,0,5.281,3.4.639.639,0,0,0,.776-.652.8.8,0,1,1,1.6-.112A2.244,2.244,0,0,1,11,13.229Z",
    transform: "translate(-0.286 -0.286)",
    fill: "#16161a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/website.2220ee5df8d8c31ab465d5273eac7480.svg";
export { ForwardRef as ReactComponent };